module.exports = __webpack_public_path__ + "img/manufacturer.9810d16e.png";